import { Post } from "../http/httpVerbs";

export const apiLogout = async () => {
    try {
        const response = await Post(`${process.env.REACT_APP_API_URL}/auth/creator/logout`);
        return response;
    } catch (error) {
        throw error;
    }
};
